<template>
  <c-view>
    <c-page>
      <div class="content">
        <div class="downbtn">
          <div class="anzhuo"
               @click="downApp"></div>
          <div class="ipod"
               @click="downApp"></div>
        </div>
      </div>
    </c-page>
  </c-view>
</template>

<script>
export default {
  name: 'DownloadPage',
  data () {
    return {
    }
  },
  components: {},
  mounted () {
  },
  methods: {
    downApp () {
      // www.i200.cn/mobile/download.aspx?from=regmobileweb
      window.location.href = '//a.app.qq.com/o/simple.jsp?pkgname=com.ShengYiZhuanJia.five'
    }
  },
  computed: {
  }
}
</script>

<style lang="scss" scoped>
@import './index';
</style>



// WEBPACK FOOTER //
// index.vue?7cf5dd67